import { useState } from 'react';
import type { AppView } from '../api/client';

/** The URL an app sends its users to. Built server-side so there is one implementation of it. */
export function LoginUrlBox({ app }: { app: AppView }) {
  const [copied, setCopied] = useState(false);

  if (!app.login_url) {
    return (
      <div className="callout callout-warn">
        No redirect URI is recorded for this app, so no sign-in URL can be built. Add one above.
      </div>
    );
  }

  return (
    <div className="field">
      <span>Sign-in URL for this app</span>
      <div className="copyrow">
        <code className="scroll">{app.login_url}</code>
        <button
          type="button"
          onClick={() => {
            void navigator.clipboard.writeText(app.login_url!).then(() => {
              setCopied(true);
              setTimeout(() => setCopied(false), 2000);
            });
          }}
        >
          {copied ? 'Copied' : 'Copy'}
        </button>
      </div>
    </div>
  );
}
